import { render, staticRenderFns } from "./AutomaticUploadsTable.vue?vue&type=template&id=2017babe&"
import script from "./AutomaticUploadsTable.vue?vue&type=script&lang=js&"
export * from "./AutomaticUploadsTable.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticUploadsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
